var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',[_c('CCardBody',[_vm._v(" 營運標籤歷程查詢 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }